// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkout-summary-wrapper {
  padding: var(--spacing-regular);
  border-radius: var(--border-radius-secondary) !important;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);
  cursor: auto;
  max-height: 550px;
}
.checkout-summary-wrapper .ant-divider-horizontal {
  margin: var(--spacing-small) 0;
}
.checkout-summary-wrapper .checkout-summary-title .vert-title {
  font-size: var(--font-medium);
  font-weight: 600;
  line-height: 24px !important;
  margin: 0;
  text-align: left;
  cursor: auto;
}
.checkout-summary-wrapper .checkout-summary-items .vert-paragraph {
  font-size: var(--font-paragraph);
  font-weight: 400;
  line-height: 20px;
  cursor: auto;
}
.checkout-summary-wrapper .checkout-summary-items .vert-paragraph.link {
  text-decoration: underline;
  cursor: pointer;
}
.checkout-summary-wrapper .checkout-summary-shipping .vert-paragraph {
  font-size: var(--font-paragraph);
  font-weight: 400;
  line-height: 20px;
  cursor: auto;
}
.checkout-summary-wrapper .checkout-summary-shipping .vert-paragraph.isFree {
  color: var(--color-highlight);
  font-weight: 500;
}
.checkout-summary-wrapper .checkout-summary-values .vert-paragraph {
  font-size: var(--font-paragraph);
  font-weight: 400;
  line-height: 20px;
  cursor: auto;
}
.checkout-summary-wrapper .checkout-summary-values .vert-paragraph.isBold {
  font-weight: 600;
}
.checkout-summary-wrapper .checkout-summary-button {
  margin-top: var(--spacing-small);
}
.checkout-summary-wrapper .divider {
  height: 1px;
  background-color: #eaeaea;
  margin: var(--spacing-small) 0;
}
.checkout-summary-disclaimer {
  font-size: var(--font-small);
  font-weight: 400 !important;
}
@media screen and (max-width: 768px) {
  .checkout-summary-wrapper {
    padding: var(--spacing-small);
    background-color: var(--color-button-text);
  }
  .checkout-summary-wrapper .mobile-checkout-summary {
    margin-bottom: var(--spacing-small);
  }
  .checkout-summary-wrapper .mobile-checkout-summary .accordion-header {
    display: flex;
    justify-content: space-between;
  }
  .checkout-summary-wrapper .mobile-checkout-summary .accordion-header .accordion-label {
    font-weight: 600;
    color: var(--color-neutral-dark-darker) !important;
  }
  .checkout-summary-wrapper .mobile-checkout-summary .accordion-header .vert-icon svg {
    fill: var(--color-neutral-dark-darker) !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Checkout/CheckoutSummaryStyles.less"],"names":[],"mappings":"AACA;EACE,+BAAA;EACA,wDAAA;EACA,gDAAA;EACA,YAAA;EACA,iBAAA;AAAF;AALA;EAQI,8BAAA;AAAJ;AARA;EAaM,6BAAA;EACA,gBAAA;EACA,4BAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;AAFN;AAhBA;EAwBM,gCAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AALN;AAOM;EACE,0BAAA;EACA,eAAA;AALR;AA1BA;EAsCM,gCAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AATN;AAWM;EACE,6BAAA;EACA,gBAAA;AATR;AApCA;EAoDM,gCAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAbN;AAeM;EACE,gBAAA;AAbR;AA7CA;EAgEI,gCAAA;AAhBJ;AAhDA;EAoEI,WAAA;EACA,yBAAA;EACA,8BAAA;AAjBJ;AAqBA;EACE,4BAAA;EACA,2BAAA;AAnBF;AAuBA;EACE;IACE,6BAAA;IACA,0CAAA;EArBF;EAmBA;IAKI,mCAAA;EArBJ;EAgBA;IAQM,aAAA;IACA,8BAAA;EArBN;EAYA;IAYQ,gBAAA;IACA,kDAAA;EArBR;EAQA;IAkBU,iDAAA;EAvBV;AACF","sourcesContent":["// DESKTOP\n.checkout-summary-wrapper {\n  padding: var(--spacing-regular);\n  border-radius: var(--border-radius-secondary) !important;\n  box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);\n  cursor: auto;\n  max-height: 550px;\n\n  .ant-divider-horizontal {\n    margin: var(--spacing-small) 0;\n  }\n\n  .checkout-summary-title {\n    .vert-title {\n      font-size: var(--font-medium);\n      font-weight: 600;\n      line-height: 24px !important;\n      margin: 0;\n      text-align: left;\n      cursor: auto;\n    }\n  }\n\n  .checkout-summary-items {\n    .vert-paragraph {\n      font-size: var(--font-paragraph);\n      font-weight: 400;\n      line-height: 20px;\n      cursor: auto;\n\n      &.link {\n        text-decoration: underline;\n        cursor: pointer;\n      }\n    }\n  }\n\n  .checkout-summary-shipping {\n    .vert-paragraph {\n      font-size: var(--font-paragraph);\n      font-weight: 400;\n      line-height: 20px;\n      cursor: auto;\n\n      &.isFree {\n        color: var(--color-highlight);\n        font-weight: 500;\n      }\n    }\n  }\n\n  .checkout-summary-values {\n    .vert-paragraph {\n      font-size: var(--font-paragraph);\n      font-weight: 400;\n      line-height: 20px;\n      cursor: auto;\n\n      &.isBold {\n        font-weight: 600;\n      }\n    }\n  }\n\n  .checkout-summary-button {\n    margin-top: var(--spacing-small);\n  }\n\n  .divider {\n    height: 1px;\n    background-color: #eaeaea;\n    margin: var(--spacing-small) 0;\n  }\n}\n\n.checkout-summary-disclaimer {\n  font-size: var(--font-small);\n  font-weight: 400 !important;\n}\n\n// MOBILE\n@media screen and (max-width: 768px) {\n  .checkout-summary-wrapper {\n    padding: var(--spacing-small);\n    background-color: var(--color-button-text);\n\n    .mobile-checkout-summary {\n      margin-bottom: var(--spacing-small);\n\n      .accordion-header {\n        display: flex;\n        justify-content: space-between;\n\n        .accordion-label {\n          font-weight: 600;\n          color: var(--color-neutral-dark-darker) !important;\n        }\n\n        .vert-icon {\n          svg {\n            fill: var(--color-neutral-dark-darker) !important;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
